module.exports = __webpack_public_path__ + "static/media/icon_tell.cdbaf4af.svg";